export const LOAD_LOGIN_DATA = 'login/LOAD_LOGIN_DATA';
export const SET_LOGIN_STATUS = 'login/SET_LOGIN_STATUS';
export const SET_ERROR_STATUS = 'login/SET_ERROR_STATUS';
export const START_LOGIN = 'login/START_LOGIN';
export const SET_PROFILE_DATA = 'login/SET_PROFILE_DATA';
export const SET_PROFILE_DATA_FROM_LOCAL_STORAGE = 'login/SET_PROFILE_DATA_FROM_LOCAL_STORAGE';